import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="switcher"
export default class extends Controller {
  static targets = ["item"]
  connect() {
  }

  show({ params }) {
    if (params.id) {
      let element = document.getElementById(params.id)
      element.classList.remove('hidden')
    } else {
      this.itemTarget.classList.remove('hidden')
    }
  }

  hide({ params }) {
    console.log(19, params);
    
    if (params.id) {
      let element = document.getElementById(params.id)
      element.classList.add('hidden')
    } else {
      this.itemTarget.classList.add('hidden')
    }
  }

  toggle() {
    this.itemTarget.classList.toggle('hidden')
  }
}
